export const PROJECT_REGULATOR_TYPE = {
	GREECE: 1,
	MALTA: 2,
	ROMANIA: 3,
    PERU: 4,
    CYPRUS: 5,
    SWEDEN: 6,
    UK: 7
};

export const PROJECT_REGULATOR_TYPE_TRANSLATIONS = {
	[PROJECT_REGULATOR_TYPE.GREECE]: "backoffice.projects.regulatorGreece",
	[PROJECT_REGULATOR_TYPE.MALTA]: "backoffice.projects.regulatorMalta",
	[PROJECT_REGULATOR_TYPE.ROMANIA]: "backoffice.projects.regulatorRomania",
    [PROJECT_REGULATOR_TYPE.PERU]: "backoffice.projects.regulatorPeru",
    [PROJECT_REGULATOR_TYPE.CYPRUS]: "backoffice.projects.regulatorCyprus",
    [PROJECT_REGULATOR_TYPE.SWEDEN]: "backoffice.projects.regulatorSweden",
    [PROJECT_REGULATOR_TYPE.UK]: "backoffice.projects.regulatorUk"
};